import {IItemContent} from "@connox/typescript-library";
import React, {Suspense} from "react";
import {useTranslation} from "react-i18next";
import ItemCard from "./ItemCard";
import styles from "./ItemsList.module.scss";

const ItemsList: React.FC<{name: string; url: string; items: IItemContent[]; swipeable?: boolean}> = ({
  name,
  items,
  url,
  swipeable = false,
}) => {
  const {t} = useTranslation();

  return (
    <Suspense fallback={null}>
      <div className={`${styles.wrapper} ${swipeable ? styles.horizontalSwiper : ""}`}>
        <h2 className={`${styles.content} ${swipeable ? styles.swiping : ""}`}>
          {t("{{name}}: Entdecken Sie die Serie zum Produkt.", {name})}
        </h2>
        <p className={`${styles.content} ${swipeable ? styles.swiping : ""}`}>
          <a href={url}>{t("Alle Produkte von {{name}}", {name})}</a>
        </p>
        <div className={styles.slider}>
          {items.map((item: IItemContent) => {
            return <ItemCard key={item.itemId} item={item} swipeable={swipeable} />;
          })}
        </div>
      </div>
    </Suspense>
  );
};

export default ItemsList;
